import React from 'react';

import { TFLoadingOverlay } from '@tf/ui';

import { useAccount } from '@/core/api/account';
import { useProfileConnectionsSchemas } from '@/core/api/profiles';
import { useAccountParams } from '@/core/hooks';

export const AccountProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const { accountId } = useAccountParams();
	const { isPending } = useAccount(accountId);
	useProfileConnectionsSchemas();

	if (isPending) {
		return <TFLoadingOverlay label="Account loading..." h={500} />;
	}

	return <>{children}</>;
};
